import { all, fork } from 'redux-saga/effects';
import PackagesSaga from './Packages.saga';
import SalonDetails from './SalonDetails.saga';
import MyBookings from './MyBookings.saga';
import SalonSide from './SalonSide.saga';
import Expenses from './Expenses.saga';
import Promo from './Promo.saga';

export default function* () {
  yield all([fork(PackagesSaga)]);
  yield all([fork(SalonDetails)]);
  yield all([fork(MyBookings)]);
  yield all([fork(SalonSide)]);
  yield all([fork(Expenses)]);
  yield all([fork(Promo)]);
}
